import { Component, Inject, OnInit, ViewEncapsulation } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { RecordAction } from "../../../../../../../../../utils/enums/shared/enums";
import { Contact } from "../../../../../../../../../utils/types/admon/contact.type";
import { ContactService } from "../../../../../../../../../services/admon/contact.service";
import { TranslateService } from "@ngx-translate/core";
import { ValidationService } from "../../../../../../../../../services/validation/validation.service";

@Component({
    selector: "wtf-contact-form",
    templateUrl: "./contact-form.component.html",
    styleUrls: ["./contact-form.component.scss"],
    encapsulation: ViewEncapsulation.None,
    providers: [ContactService, ValidationService],
})
export class ContactFormComponent implements OnInit {
    contact: Contact = new Contact();
    dialogTitle: string;
    contactForm: FormGroup;
    action: RecordAction;
    callback: (contact) => void;

    recordAction = RecordAction;
    form: FormGroup;

    constructor(
        public dialogRef: MatDialogRef<ContactFormComponent>,
        @Inject(MAT_DIALOG_DATA) private data: any,
        private contactService: ContactService,
        private translateService: TranslateService,
        private validationService: ValidationService
    ) {
        this.translateService.setDefaultLang("en");
        this.translateService.use(localStorage.getItem("language") || "en");
        this.action = data.action;
        this.callback = data.callback;

        if (
            this.action === RecordAction.Update ||
            this.action === RecordAction.View
        ) {
            this.contact = data.contact;

            this.dialogTitle = this.contact.name;
        } else {
            this.dialogTitle = "Nuevo Contacto";
            this.dialogTitle = this.translateService.instant(this.dialogTitle);
        }

        this.contactForm = this.createForm();
    }

    ngOnInit() {}

    isControlValid(form: FormGroup, field: string) {
        return this.validationService.isValidField(form, field);
    }

    getErrorMessage(form: FormGroup, field: string, text: string) {
        return this.validationService.getErrorMessage(form, field, text);
    }

    createForm() {
        this.form = new FormGroup({
            name: new FormControl(this.contact.name, [
                Validators.required,
                Validators.pattern(
                    "^[a-zA-ZñÑÀ-ú0-9_]+( [a-zA-ZñÑÀ-ú0-9_]+)*$"
                ),
            ]),
            role: new FormControl(this.contact.role, [
                Validators.required,
                Validators.pattern(
                    "^[a-zA-ZñÑÀ-ú0-9_]+( [a-zA-ZñÑÀ-ú0-9_]+)*$"
                ),
            ]),
            phoneNumber: new FormControl(this.contact.phoneNumber, [
                Validators.pattern("^[0-9]+$"),
                Validators.required,
                Validators.minLength(12),
                Validators.maxLength(12),
            ]),
            email: new FormControl(this.contact.email, [
                Validators.email,
                Validators.required,
            ]),
        });

        const form = this.form;

        form.controls["name"].valueChanges.subscribe(
            (value) => (this.contact.name = value)
        );
        form.controls["role"].valueChanges.subscribe(
            (value) => (this.contact.role = value)
        );
        form.controls["phoneNumber"].valueChanges.subscribe(
            (value) => (this.contact.phoneNumber = value)
        );
        form.controls["email"].valueChanges.subscribe(
            (value) => (this.contact.email = value)
        );
        return form;
    }

    saveContact() {
        console.log(this.contactForm.controls["email"].hasError("email"));

        // if (this.contactForm.invalid) {
        //     return;
        // }

        // this.callback(this.contact);
    }
}
